import analyticstracker from "@jmc/analyticstracker";
import { useCookieInteraction } from "@jmc/core/src/hooks/useCookieInteraction/index";
import { EventTypes } from "@jmc/core/src/types/EventTypes";
import { useJnjBranding } from "@jmc/utils/hooks/useJnjBranding";
import { useScroll } from "@jmc/utils/hooks/useScroll";
import React from "react";

export interface PropTypes {
    children: JSX.Element | JSX.Element[];
    name: string;
    position: number;
}

export const SectionImpression = (props: PropTypes): JSX.Element => {
    const { children, name, position } = props;
    const { interacted } = useCookieInteraction();
    const { jnjFullBranded } = useJnjBranding();

    useScroll(() => {
        if (interacted) {
            analyticstracker().trackImpression(EventTypes.SECTION_IMPRESSION);
        }
    }, 500);

    return (
        <div
            role="none"
            data-tracking-event={EventTypes.SECTION_IMPRESSION}
            data-tracking-info={JSON.stringify({ name, position })}
            style={{ display: jnjFullBranded ? "flex" : "block" }} // for some inexplicable reason, this is necessary to avoid whitespace between some sections
        >
            {children}
        </div>
    );
};

export default SectionImpression;
